import UserInfo from "./UserInfo";

export default {
  text: "Configurações",
  icon: "preferences",
  items: [
    {
      text: "Configurações",
      path: "/configs",
    },
    {
      text: "Prefeituras",
      path: "/prefeituras",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Usuários",
      path: "/usuarios",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Enviar Acessos em Massa",
      path: "/enviar-acessos-em-massa",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Ferramentas NFS-e",
      path: "/ferramentas-nfse",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Taxas",
      path: "/taxas",
    },
    {
      text: "Receitas",
      path: "/receitas",
    },
    {
      text: "Tipos de Veículos",
      path: "/tipos_veiculos",
    },
    {
      text: "Tipos de CND",
      path: "/tipocertidao",
    },
    {
      text: "Natureza ITBI",
      path: "/naturezaoperacao",
    },
    {
      text: "Tipos Alvará Construção",
      path: "/tipos_alvara_construcao",
    },
    {
      text: "Juros",
      path: "/juros",
    },
    {
      text: "Tipo Uso de Logradouro Público",
      path: "/tipos_uso_logradouro_publico",
    },
    {
      text: "Feriados",
      path: "/feriados",
    },
    {
      text: "Leis",
      path: "/leis",
    },
    {
      text: "Agentes Recebedores",
      path: "/agentesrecebedores",
    },
    {
      text: "Texto CDA",
      path: "/textoscda",
    },
    {
      text: "Contas Bancárias",
      path: "/contasbancarias",
    },
    {
      text: "Parametros Refis",
      path: "/refis",
    },
    {
      text: "Unidades Fiscais",
      path: "/unidadesfiscais",
    },
    {
      text: "Tipo Alvará Diverso",
      path: "/alvarasdiversos",
    },
    {
      text: "Documentos de Retenção",
      path: "/documentosretencoes",
    },
    {
      text: "Séries NF",
      path: "/seriesnf",
    },
    {
      text: "Parâmetros de IPTU",
      path: "/parametrosiptu",
    },
    {
      text: "Fórmulas de IPTU",
      path: "/formulasiptu",
    },
    {
      text: "Motivos",
      path: "/motivosisencaoiptu",
    },
    {
      text: "Preço Público",
      path: "/precopublico",
    },
    {
      text: "Qualificação Sócios",
      path: "/qualificacaosocios",
    },
    {
      text: "Valor Edificado",
      path: "/valoredificado",
    },
    {
      text: "Análises",
      path: "/analises",
    },
    {
      text: "Conta Cosif",
      path: "/contascosif",
    },
    {
      text: "Calendário ISS",
      path: "/calendarioiss",
    },
    {
      text: "Recurso",
      path: "/recursos",
    },
    {
      text: "Grupo de Recurso",
      path: "/gruporecurso",
    },
    {
      text: "Status de Protocolo",
      path: "/statusprotocolo",
    },
    {
      text: "Setor de Atendimento de Protocolo",
      path: "/setoratendimentoprotocolo",
    },
    {
      text: "Tipo de Protocolo",
      path: "/tipoprotocolo",
    },
    {
      text: "Usuários Prefeitura",
      path: "/usuariosprefeitura",
    },
    {
      text: "Auditoria",
      path: "/auditoria"
    },
    {
      text: "Índices Trimap",
      path: "/indicestrimap"
    },
    {
      text: "Calendário de Índices Trimap",
      path: "/calendarioindicestrimap"
    },
    {
      text: "Enviar PGDAS-D",
      path: "/enviar-arquivos/pgdasd"
    },
    {
      text: "Parametros Livro Dívida Ativa",
      path: "/parametros_livro_diat"
    },
    {
      text: "Parametros PIX",
      path: "/parametros_pix"
    },
    {
      text: "Restaurar NFS-e",
      path: "/restaurar-nf",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Cancelar Escrituração",
      path: "/cancelar-escrituracao",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Situações DIAT",
      path: "/situacoesdiat",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Tipos de Notificações",
      path: "/tiposdenotificacoes",
    },
    {
      text: "Pré-Migração CPBS",
      path: "/premigracaocpbs",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Fatores Corretivos",
      path: "/fatorescorretivos",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Cadastro Modelos",
      path: "/cadastro-modelos",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Cadastro Modelos (Prefeitura)",
      path: "/cadastro-modelos-prefeitura",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Unificação de Cadastros",
      path: "/unificacaocadastros",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Conf. Número Complemento",
      path: "/conf_numero_complemento",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Conf. Logradouro",
      path: "/conf_logradouro",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
    {
      text: "Acessos NFS-e Antiga",
      path: "/acessos-nfse-antiga",
      visible: UserInfo.possuiPerfil(["trimap"]),
    },
  ],
};
